<template>
  <div class="row">
    <div class="d-flex justify-content-between ml-3 mr-2" style="width: 100%">
      <div>
        <cabecalho
          title="ACADEMICO_MATRICULAS.DADOS_RESPONSAVEIS"
          title_type="body"
        />
      </div>
    </div>
    <div class="col-12">
      <b-table
        :empty-text="$t('GERAL.NENHUM_REGISTRO')"
        head-variant="light"
        :fields="campos"
        :items="vinculos"
        show-empty
        responsive
        striped
        hover
      >
        <template #cell(contatos)="item">
          <b-button variant="primary" @click="contatos(item.item)">
            Contatos
          </b-button>
        </template>

        <template #cell(enderecos)="item">
          <b-button variant="primary" @click="enderecos(item.item)">
            Endereços
          </b-button>
        </template>
      </b-table>
    </div>
    <modal-vinculos-contatos
      :exibir="exibirModalContatos"
      :pessoaSelecionada="pessoaSelecionada"
      @fechar="fecharModalContatos"
    />
    <modal-vinculos-enderecos
      :exibir="exibirModalEnderecos"
      :pessoaSelecionada="pessoaSelecionada"
      @fechar="fecharModalEnderecos"
    />
  </div>
</template>
<script>
import { Cabecalho } from '@/components/headers/index';
import ModalVinculosContatos from '@/views/academico/matriculas/components/ModalVinculosContatos.vue'
import ModalVinculosEnderecos from '@/views/academico/matriculas/components/ModalVinculosEnderecos.vue'

export default {
  components: {
    Cabecalho,
    ModalVinculosContatos,
    ModalVinculosEnderecos,
  },
  props: {
    vinculos: { type: Array, default: Array },
  },
  data() {
    return {
      pessoaSelecionada: {},
      exibirModalContatos: false,
      exibirModalEnderecos: false,
      campos: [
        {
          key: 'codigo',
          label: 'Código pessoa',
          sortable: true,
        },
        {
          key: 'nome',
          label: 'Nome',
          sortable: true,
        },
        {
          key: 'tipoFiliacaoDescricao',
          label: 'Filiação',
          sortable: true,
        },
        {
          key: 'tipoResponsavelDescricao',
          label: 'Responsável por',
          sortable: true,
        },
        {
          key: 'contatos',
          label: 'Contatos',
        },
        {
          key: 'enderecos',
          label: 'Endereços',
        },
        {
          key: 'acoes',
          label: 'Mais ações',
        },
      ],
    };
  },

  methods: {
    fecharModalContatos() {
      this.exibirModalContatos = false;
      this.pessoaSelecionada = {};
    },
    contatos(pessoaSelecionada) {
      this.exibirModalContatos = true;
      this.pessoaSelecionada = pessoaSelecionada;
    },
    fecharModalEnderecos() {
      this.exibirModalEnderecos = false;
      this.pessoaSelecionada = {};
    },
    enderecos(pessoaSelecionada) {
      this.exibirModalEnderecos = true;
      this.pessoaSelecionada = pessoaSelecionada;
    },
  },
};
</script>
